import {
  OptimizationEmployeeLeavingData,
  OptimizationSoftwareAccountDuplicateData,
  OptimizationSoftwareAccountRedundantLicenseData,
  OptimizationSoftwareAccountUnusedData,
  OptimizationType,
} from '@/client'
import { editToast, sendToast } from '@/components/sm/SmNotification'
import i18n from '@/i18n/i18n'
import { OptimizationStore } from '@/stores/optimization/optimization.store'
import dayjs from 'dayjs'

// Generate optimization reason description
export function getReason(
  type: OptimizationType,
  data:
    | OptimizationEmployeeLeavingData
    | OptimizationSoftwareAccountDuplicateData
    | OptimizationSoftwareAccountRedundantLicenseData
    | OptimizationSoftwareAccountUnusedData
): string {
  switch (type) {
    case OptimizationType.EMPLOYEE_LEAVING:
      return i18n.global.t('optimizationMessage.employeeLeaving')
    case OptimizationType.SOFTWARE_ACCOUNT_DUPLICATE: {
      const info = data as OptimizationSoftwareAccountDuplicateData
      return i18n.global.t('optimizationMessage.softwareAcountDuplicate', {
        count: info?.software_account_ids.length,
      })
    }
    case OptimizationType.SOFTWARE_ACCOUNT_REDUNDANT_LICENSES: {
      const info = data as OptimizationSoftwareAccountRedundantLicenseData
      const totalLength = new Set(
        info.redundant_software_licenses.flatMap(
          (item) => item.redundant_software_license_ids
        )
      ).size
      return i18n.global.t(
        'optimizationMessage.softwareAccountRedundantLicenses',
        {
          count: totalLength,
        }
      )
    }
    case OptimizationType.SOFTWARE_ACCOUNT_UNUSED: {
      const info = data as OptimizationSoftwareAccountUnusedData
      if (info.never_logged_in) {
        return i18n.global.t(
          'optimizationMessage.softwareAccountUnusedNeverLoggedIn'
        )
      } else {
        const daysSince = dayjs().diff(dayjs(info?.last_login_time), 'day')
        return i18n.global.t('optimizationMessage.softwareAccountUnused', {
          days: daysSince,
        })
      }
    }
    case OptimizationType.SOFTWARE_ACCOUNT_RIGHTSIZING: {
      return i18n.global.t('optimizationMessage.softwareAccountRightsizing')
    }
    default:
      return ''
  }
}

export async function refetchOptimizations() {
  const toast = sendToast(
    i18n.global.t('reloadOptimizations'),
    undefined,
    'loading'
  )
  await OptimizationStore.updateOptimizationCacheFromApi(true)
  await OptimizationStore.updateSavingsCacheFromApi()

  editToast(toast, {
    title: i18n.global.t('notification.loadingSuccess'),
    type: 'success',
  })
}
